import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
const pains = ['¿No sabes en qué se fue el dinero?', 'La quincena desaparece en gastos hormiga', 'Te da ansiedad ver el banco', 'Pagas mínimos y no avanzas en deudas', 'No logras ahorrar ni poquito', 'Las apps de domicilio y transporte se comen todo', 'Los antojos ganan siempre', 'Te cuesta decir no cuando familia o pareja pide dinero'];
export function PainPoints() {
  return <section className="py-10 bg-white" data-id="element-181">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-182">
        <div className="text-center mb-12" data-id="element-183">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-brand-dark mb-4" data-id="element-184">
            ¿Te pasa esto?
          </h2>
          <div className="w-16 h-1 bg-brand-gold mx-auto rounded-full" data-id="element-185"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-186">
          {pains.map((pain, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="flex items-start gap-3 p-4 rounded-lg hover:bg-brand-cream/30 transition-colors" data-id="element-187">
              <XCircle className="w-6 h-6 text-red-400 flex-shrink-0 mt-0.5" data-id="element-188" />
              <p className="font-sans text-brand-text text-lg" data-id="element-189">{pain}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}